export enum MerchantNoteLabel {
  SALES = 'SALES',
  SUPPORT = 'SUPPORT',
}
